module.exports = __webpack_public_path__ + "static/img/test-center.0f30e5b7.png";